<template>
  <div class="employer-specialists-view container-fluid">
    <div class="row">
      <dd class="col-sm-6" v-if="flexAe && showFlex">
        <h6 class="font-weight-bold">Primary Contact</h6>
        <p>{{flexAe}}</p>
        <p>Client Relationship Manager</p>
        <p v-if="flexAePhone && flexAePhoneExt && !shouldHidePhoneForExtension(flexAePhoneExt)"><a :href="`tel:${flexAePhone}${flexAePhoneExt ? ',,' + flexAePhoneExt : ''}`">{{$formatters.phoneAndExt(flexAePhone, flexAePhoneExt)}}</a></p>
        <p v-if="flexAeEmail"><a :href="`mailto:${flexAeEmail}`">{{flexAeEmail}}</a></p>
        <p v-if="flexAePhone && flexAePhoneExt && shouldShowChatForExtension(flexAePhoneExt)"><a href="#" @click.prevent="openChat(flexAePhoneExt)">Start Chat</a></p>
        <p v-if="flexAeCalendlyLink"><a :href="flexAeCalendlyLink" target="_blank">Schedule a meeting</a></p>
      </dd>

      <dd class="col-sm-6" v-if="cobraAe && showCobra">
        <h6 class="font-weight-bold">COBRA Contact</h6>
        <p>{{cobraAe}}</p>
        <p>Client Relationship Manager</p>
        <p v-if="cobraAePhone && !shouldHidePhoneForExtension(cobraAePhoneExt)"><a :href="`tel:${cobraAePhone}${cobraAePhoneExt ? ',,' + cobraAePhoneExt : ''}`">{{$formatters.phoneAndExt(cobraAePhone, cobraAePhoneExt)}}</a></p>
        <p v-if="cobraAeEmail"><a :href="`mailto:${cobraAeEmail}`">{{cobraAeEmail}}</a></p>
        <p v-if="cobraAePhone && shouldShowChatForExtension(cobraAePhoneExt)"><a href="#" @click.prevent="openChat(cobraAePhoneExt)">Start Chat</a></p>
        <p v-if="cobraAeCalendlyLink"><a :href="cobraAeCalendlyLink" target="_blank">Schedule a meeting</a></p>
      </dd>

      <dd class="col-sm-6" v-if="rsmAe && showSales">
        <h6 class="font-weight-bold">Sales Contact</h6>
        <p>{{rsmAe}}</p>
        <p>VP of Sales</p>
        <p v-if="rsmAePhone"><a :href="`tel:${rsmAePhone}${rsmAePhoneExt ? ',,' + rsmAePhoneExt : ''}`">{{$formatters.phoneAndExt(rsmAePhone, rsmAePhoneExt)}}</a></p>
        <p v-if="rsmAeEmail"><a :href="`mailto:${rsmAeEmail}`">{{rsmAeEmail}}</a></p>
        <p v-if="rsmAeCalendlyLink"><a :href="rsmAeCalendlyLink" target="_blank">Schedule a meeting</a> </p>
      </dd>

      <dd class="col-sm-6" v-if="css && showCss">
        <h6 class="font-weight-bold">Onboarding / Renewal Contact</h6>
        <p>{{css}}</p>
        <p>Client Success Specialist</p>
        <p v-if="cssPhone && !shouldHidePhoneForExtension(cssPhoneExt)"><a :href="`tel:${cssPhone}${cssPhoneExt ? ',,' + cssPhoneExt : ''}`">{{$formatters.phoneAndExt(cssPhone, cssPhoneExt)}}</a></p>
        <p v-if="cssEmail"><a :href="`mailto:${cssEmail}`">{{cssEmail}}</a></p>
        <p v-if="cssCalendlyLink"><a :href="cssCalendlyLink" target="_blank">Schedule a meeting</a></p>
      </dd>

      <dt class="col-sm-12" v-if="employerId">
        <a href="#" @click.prevent="goToTeam"><h6>Your Client Relationship Team Members</h6></a>
      </dt>
    </div>
  </div>
</template>

<script>

import {chatService} from "../framework/utils/chat-service";
import ameriflexSpecialistsMixin from "../framework/utils/ameriflex-specialists-mixin";

export default {
  name: 'employer-specialists-view',
  inject: ['closeModal'],
  mixins: [ameriflexSpecialistsMixin],
  data() {
    return {
      title: 'Contact Us',
      data: {
        returnUrl: null
      }
    }
  },
  computed: {
    ...amfx.map('employer', 'employerId'),
    ...amfx.map('employer/specialists', "state.*"),
    ...amfx.map('session', 'isPlanAdmin,isBroker'),

    buttons() {
      return "Close";
    }
  },
  methods: {
    goToTeam() {
      if (this.$router) {
        this.$router.push(`/employer/${this.employerId}/team`);
      } else {
        this.data.returnUrl = `/employer/${this.employerId}/team`;
      }

      if (this.closeModal)
        this.closeModal(this.data);
    },
    openChat(forExtension) {
      chatService.openChat(forExtension);
    },
  }
}
</script>

<style lang="scss" scoped>
.employer-specialists-view {
  dd {
    margin-bottom: 15px;
  }
  p {
    margin-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/employer/EmployerSpecialistsView.vue